import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoardSnowBottom = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 208,
	height: 11,
	fill: "none",
	viewBox: "0 0 208 11",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M0 5.42s4.02.27 9.4 1.77c5.36 1.5 44.33.52 73.98 1.02 14.12.24 22.04 0 36.17 0 11.78 0 18.39-.11 30.17 0 19.32.18 31.14 5.3 49.45 1.22 3.5-.78 8.29-1.44 8.73-2.38.44-.94-.3-3.4-6.75-5.75-8.07-2.92-17.62-.21-22.07 1.3-4.44 1.52-17.62 1.63-22.88 0-5.27-1.62-12.68 0-18.12 1.63-5.43 1.62-12.67 0-14.98-1.63-2.3-1.62-10.7 0-15.64 1.63-3.95 1.3-10.98.54-14 0-4.44-.54-15.14-1.63-22.39-1.63-9.05 0-16.3 1.63-22.4 0-4.87-1.3-11.13.54-13.66 1.63-2.41 0-7.97-.33-10.86-1.63C21.25 1.3 1.47 4.88 0 5.42Z"
	})
});
export default SvgBoardSnowBottom;
